export default "__VITE_ASSET__9aa0bec8__"